import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AlertService} from '../../shared/services/alert.service';
import {Messages} from '../../shared/constants/messages';
import {PermissionService} from '../services/permission.service';
import {SystemPower} from '../../shared/model/permissions';

export const adminGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const alertService: AlertService = inject(AlertService);
  const permissionService: PermissionService = inject(PermissionService);

  if (permissionService.isLogged() && permissionService.hasSystemPower(SystemPower.ADMINISTRATOR)) {
    return true;
  }

  alertService.showError(Messages.ADMIN_ONLY);
  return router.navigate(['/home']);
};


